module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-md-1-5 pure-u-lg-1-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-3-5 pure-u-lg-1-2"
  }, [_c('div', {
    staticClass: "content box padding-30-reactive"
  }, [(_vm.active) ? _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1-2"
  }, [_c('h3', {
    staticClass: "responsive"
  }, [_vm._v(_vm._s(_vm.step) + ". Review")])]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 spacing-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1"
  }, [_vm._l((_vm.summary), function(text) {
    return _c('div', {
      staticClass: "summary"
    }, [_c('div', {
      staticClass: "pure-u-sm-1-4"
    }), _vm._v(" "), _c('div', {
      staticClass: "pure-u-1 pure-u-sm-1-2 padding-bottom-10"
    }, [_vm._v(_vm._s(text))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 spacing-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-2"
  }, [_c('button', {
    staticClass: " pure-button pure-button-primary block padding-10 margin-10 margin-left-0",
    on: {
      "click": _vm.success
    }
  }, [_vm._v("\n              " + _vm._s(_vm.buttonText) + "\n            ")])])], 2)]) : _c('div', {
    staticClass: "pure-u-1"
  }, [_c('h3', {
    staticClass: "responsive"
  }, [_vm._v(_vm._s(_vm.step) + ". Review")]), _vm._v(" "), (_vm.canEdit && !_vm.active) ? _c('button', {
    staticClass: "link-lookalike",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Review")]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-025afb5d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/review/ReviewDirect.vue
// module id = 356
// module chunks = 1